export const navigationName = [
  {id: '1', value: 'Курси', name: 'courses'},
  {id: '2', value: 'Про нас', name: 'header'},
  {id: '3', value: 'Відгуки', name: 'reviews'},
  {id: '4', value: 'Блог', name: 'blog'},
]

export const wiringBlock = [
  {id: 1, value: '', number: '24.08.23'},
  {id: 2, value: 'місяць', number: '1'},
  {id: 3, value: 'тис. грн', number: '3'},
]

export const textAboutUsBlock = 'Поєднання теорії та практики, здобуття цінного прикладного\n' +
  ' досвіду шляхом практичних вправ, симуляцій та взаємодії з\n віртуальними об\'єктами';

export const textAboutUsBlockBottom = 'Спеціалізована школа будівельної сфери для любителів та професіоналів. Наша мета — це надати можливості для вивчення теорії, ознайомлення з інноваційними технологіями і здобуття практичних навичок. Тут зможете знайти стимулююче середовище, яке сприяє постійному освоєнню нового, а також  збагатитися перевіреними контактами і рекомендаціями, отримавши підтримку від спільноти однодумців.'

export const coursesCard = [
  {
    id: 1,
    image: 'engineer',
    value: '“Електрика І рівень”',
    priceNumber: '1',
    price: 'тис.грн',
    periodNumber: '3',
    period: 'місяць',
    start: '12.08.23'
  },
  {
    id: 2,
    image: 'carpenter',
    value: '“Столяр PRO”',
    priceNumber: '2',
    price: 'тис.грн',
    periodNumber: '2',
    period: 'місяць',
    start: '11.09.23'
  },
  {
    id: 3,
    image: 'maintenance',
    value: '“Штукатурка”',
    priceNumber: '3',
    price: 'тис.грн',
    periodNumber: '1',
    period: 'місяць',
    start: '12.03.23'
  },
]

export const testUsefulInformationBlock1 = 'Наші курси по будівництву і ремонту будуть корисними для всіх, хто бажає здобути знання про будівельні процеси та технології. Вони допомагають покращити ремонтні та будівельні вміння, збільшити ефективність та якість робіт, а також розвинути професійну кар\'єру у будівельній галузі. Навчання в цій сфері може стати цінним активом для особистого зростання і розвитку в професійній діяльності'

export const testUsefulInformationBlock2 = 'Навчання на будівельника може виявитися високо перспективною інвестицією у майбутню кар\'єру, дозволяючи отримати стабільну та задовільну роботу у розмаїтті сфер будівельної галузі.'

export const userReviews = [
  {
    id: 1,
    name: 'Олексій Карась,  електрик',
    value: 'Я мав базові знання, самоучка. Оскільки робота в мене досить серйозна, хотів переконатися, що мої навички відповідають всім нормам. Закріпив свої знання та отримав нові.'
  },
  {
    id: 2,
    name: 'Максим Коваль,  дизайнер',
    value: 'Я прихильник свідомого підходу до дизайну, надаю своїм клієнтам не лише гарну картинку, а весь комплексний проект. Для мене було важливо отримати базові знання в дотичних сферах.'
  },
  {
    id: 3,
    name: 'Антон Тимченко,  слюсар',
    value: 'Курс мені сподобався, структурований та змістовний. Я оновив свої знання, дізнався про нові підходи. Багато реальних прикладів і практичної частини.'
  },
  {
    id: 4,
    name: 'Ігор Бірченко,  слюсар',
    value: 'Курс мені сподобався, структурований та змістовний. Я оновив свої знання, дізнався про нові підходи. Багато реальних прикладів і практичної частини.'
  }
]

export const SubscriptionBlockText = 'Підписуючись, Ви отримуєте можливість отримувати на свою поштову скриню новини про всі курси та навчальні програми від BuildTechPro'

export const blockBlog = [
  {
    id: 1,
    style: 'w-[37.5%] border border-regal-black border-opacity-10',
    styleTitle: 'mr-[30%]',
    image: 'wiring',
    title: 'Оптимізація електропроводки',
    value: 'Оптимізація електропроводки в будинку або офісі має на меті підвищення ефективності та безпеки електричної системи. Кроки, які можна зробити для оптимізації електропроводки: 1) перевірка і заміна застарілих дротів...'
  },
  {
    id: 2,
    style: 'w-[37.5%] border border-regal-black border-opacity-10',
    styleTitle: 'mr-[30%]',
    image: 'ventilation',
    title: 'Нові стандарти вентиляції',
    value: 'Стандарти встановлюють оптимальну кількість обмінів повітря за годину для різних типів приміщень. Це важливо для запобігання накопиченню забрудненого повітря і підтримання свіжого та здорового середовища...  '
  },
  {
    id: 3,
    style: 'w-[25%] border border-regal-black border-opacity-10',
    styleTitle: 'mr-[0%]',
    image: 'plumbing',
    title: 'Заміна клапана в сантехніці',
    value: 'Заміна клапана в сантехнічних системах може бути простою процедурою, яку можна виконати самостійно або скористатися послугами професіонала сантехніка. Все залежить від складності роботи та вашого рівня досвіду.'
  },
]

export const footerText = 'Права на всі матеріали, представлені на платформі BuildTechPro, захищено. Використання статей, відео чи ілюстрацій обов\'язково має бути погоджено. З будь-якими запитами, питаннями та пропозиціями пишіть на '
